import { login } from "./authApi";
import { explainAuthError, useAuthStore } from "./authStore";

/**
 * Email/password login: POST the credentials → store the session. The
 * backend returns a coarse 401 for any bad credential, so we surface a
 * single non-leaky message via `explainAuthError`.
 */
export function useEmailLogin() {
	const setStatus = useAuthStore((s) => s.setStatus);
	const setError = useAuthStore((s) => s.setError);
	const setSession = useAuthStore((s) => s.setSession);

	async function runLogin(email: string, password: string): Promise<void> {
		try {
			setError(null);
			setStatus("submitting");

			const result = await login(email, password);
			setSession(result);
		} catch (err) {
			setError(explainAuthError(err));
			setStatus("error");
		}
	}

	return { runLogin };
}
